<template>
  <div class="balance-page">
    <div class="header-section">
      <!-- <h2>账户余额</h2> -->
      <div class="balance-card">
        <div class="balance-info">
          <div class="balance-item">
            <span class="label">当前余额</span>
            <span class="value">{{ userBalance.remaining_tokens || 0 }}</span>
            <span class="unit">tokens</span>
          </div>
          <div class="balance-item">
            <span class="label">累计消费</span>
            <span class="value">{{ userBalance.used_tokens || 0 }}</span>
            <span class="unit">tokens</span>
          </div>
        </div>
        <el-button type="primary" @click="showRechargeModal = true" class="recharge-btn">
          立即充值
        </el-button>
      </div>
    </div>

    <!-- 标签页 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="使用记录" name="usage">
        <div class="records-section">
          <div class="filter-bar">
            <el-date-picker
              v-model="usageFilter.dateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="fetchUsageHistory">
            </el-date-picker>
            <el-button @click="refreshUsageHistory">刷新</el-button>
          </div>
          
          <el-table :data="usageHistory" style="width: 100%" v-loading="usageLoading">
            <el-table-column prop="created_at" label="日期" width="200" align="center">
              <template slot-scope="scope">
                {{ formatDateTime(scope.row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column prop="usage_type" label="使用类型" width="150" align="center" />
            <el-table-column prop="description" label="描述" min-width="200" />
            <el-table-column prop="tokens" label="消耗Tokens" width="120" align="center">
              <template slot-scope="scope">
                <span class="tokens-used">-{{ scope.row.tokens }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remaining_tokens" label="剩余Tokens" width="120" align="center" />
          </el-table>
          
          <el-pagination
            @current-change="handleUsagePageChange"
            :current-page="usageCurrentPage"
            :page-size="pageSize"
            :total="usageTotalCount"
            layout="total, prev, pager, next"
            class="pagination">
          </el-pagination>
        </div>
      </el-tab-pane>

      <el-tab-pane label="购买记录" name="purchase">
        <div class="records-section">
          <div class="filter-bar">
            <el-date-picker
              v-model="purchaseFilter.dateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="fetchPurchaseHistory">
            </el-date-picker>
            <el-button @click="refreshPurchaseHistory">刷新</el-button>
          </div>
          
          <el-table :data="purchaseHistory" style="width: 100%" v-loading="purchaseLoading">
            <el-table-column prop="order_id" label="订单号" width="200" align="center" />
            <el-table-column prop="package_name" label="套餐名称" width="150" align="center" />
            <el-table-column prop="tokens" label="Tokens数量" width="120" align="center">
              <template slot-scope="scope">
                <span class="tokens-gained">+{{ scope.row.tokens }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="支付金额" width="120" align="center">
              <template slot-scope="scope">
                <span>¥{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payment_method" label="支付方式" width="120" align="center" />
            <el-table-column prop="status" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <span :class="getStatusClass(scope.row.status)">
                  {{ getStatusText(scope.row.status) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="paid_at" label="购买时间" width="180" align="center">
              <template slot-scope="scope">
                {{ formatDateTime(scope.row.paid_at) }}
              </template>
            </el-table-column>
          </el-table>
          
          <el-pagination
            @current-change="handlePurchasePageChange"
            :current-page="purchaseCurrentPage"
            :page-size="pageSize"
            :total="purchaseTotalCount"
            layout="total, prev, pager, next"
            class="pagination">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 充值弹窗 -->
    <el-dialog
      title="充值 Tokens"
      :visible.sync="showRechargeModal"
      :width="isMobile ? '95%' : '600px'"
      :close-on-click-modal="false">
      <div class="recharge-content">
        <div class="packages-grid">
          <div 
            v-for="pkg in rechargePackages"
            :key="pkg.package_id"
            :class="['package-card', { 'selected': selectedPackage?.package_id === pkg.package_id }]"
            @click="selectPackage(pkg)">
            <div class="package-header">
              <h3>{{ pkg.tokens/10000 }}万字符</h3>
              <div class="package-price">¥{{ pkg.price }}</div>
            </div>
            <div class="package-desc">{{ pkg.description }}</div>
            <div class="package-bonus" v-if="pkg.bonus_tokens > 0">
              赠送{{ pkg.bonus_tokens/10000 }}字符
            </div>
          </div>
        </div>

        <div class="payment-section" v-if="selectedPackage">
          <h4>支付方式</h4>
          <div class="payment-methods">
            <div v-show="false"
              :class="['payment-method', { 'selected': paymentMethod === 'alipay' }]"
              @click="paymentMethod = 'alipay'">
              <img src="@/assets/images/payment/alipay.png" alt="支付宝" />
              <span>支付宝</span>
            </div>
            <div 
              :class="['payment-method', { 'selected': paymentMethod === 'wechat' }]"
              @click="paymentMethod = 'wechat'">
              <img src="@/assets/images/payment/wechat.png" alt="微信支付" />
              <span>微信支付</span>
            </div>
          </div>
          
          <div class="order-summary">
            <div class="summary-item">
              <span>套餐:</span>
              <span>{{ selectedPackage.tokens }}万字符</span>
            </div>
            <div class="summary-item total">
              <span>应付金额:</span>
              <span class="price">¥{{ selectedPackage.price }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRechargeModal = false">取 消</el-button>
        <el-button type="primary" @click="handleRecharge" :disabled="!selectedPackage || !paymentMethod" :loading="rechargeLoading">
          立即支付
        </el-button>
      </div>
    </el-dialog>

    <!-- 支付状态弹窗 -->
    <el-dialog
      title="支付"
      :visible.sync="showPaymentStatusModal"
      :width="isMobile ? '95%' : '500px'"
      :close-on-click-modal="false"
      :show-close="false">
      <div class="payment-status-content">
        <!-- 显示二维码的状态 -->
        <div v-if="paymentStatus === 'pending'" class="qr-code-section">
          <div class="payment-info">
            <h3>请使用{{ paymentMethod === 'alipay' ? '支付宝' : '微信' }}扫码支付</h3>
            <div class="order-amount">¥{{ selectedPackage?.price }}</div>
          </div>
          
          <div class="qr-code-container">
            <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="支付二维码" class="qr-code" />
            <div v-else class="qr-code-loading">
              <i class="el-icon-loading"></i>
              <p>正在生成支付二维码...</p>
              <el-button size="small" @click="retryGenerateQRCode">重新生成</el-button>
            </div>
            
            <div class="qr-code-tips" v-if="qrCodeUrl">
              <p>请在手机上打开{{ paymentMethod === 'alipay' ? '支付宝' : '微信' }}扫一扫</p>
              <p>扫描上方二维码完成支付</p>
            </div>
          </div>
          
          <div class="payment-countdown" v-if="paymentCountdown > 0">
            <p>支付剩余时间：{{ Math.floor(paymentCountdown / 60) }}分{{ paymentCountdown % 60 }}秒</p>
          </div>
        </div>
        
        <!-- 其他状态显示 -->
        <div v-else class="status-display">
          <div class="status-icon">
            <div v-if="paymentStatus === 'pending'" class="status-loading">
              <i class="el-icon-loading"></i>
            </div>
            <div v-else-if="paymentStatus === 'success'" class="status-success">
              <i class="el-icon-circle-check"></i>
            </div>
            <div v-else-if="paymentStatus === 'failed'" class="status-failed">
              <i class="el-icon-circle-close"></i>
            </div>
            <div v-else-if="paymentStatus === 'timeout'" class="status-timeout">
              <i class="el-icon-time"></i>
            </div>
          </div>
          
          <div class="status-text">
            <h3 v-if="paymentStatus === 'pending'">正在创建订单...</h3>
            <h3 v-else-if="paymentStatus === 'success'">支付成功！</h3>
            <h3 v-else-if="paymentStatus === 'failed'">支付失败</h3>
            <h3 v-else-if="paymentStatus === 'timeout'">支付超时</h3>
            
            <p v-if="paymentStatus === 'pending'">正在生成支付二维码，请稍候...</p>
            <p v-else-if="paymentStatus === 'success'">{{ tokensAdded || 0 }} tokens已成功充值到您的账户</p>
            <p v-else-if="paymentStatus === 'failed'">支付未成功，请重新尝试</p>
            <p v-else-if="paymentStatus === 'timeout'">支付时间过长，订单已关闭</p>
          </div>
        </div>
        
        <div class="order-info" v-if="currentOrderId">
          <p>订单号: {{ currentOrderId }}</p>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button v-if="paymentStatus === 'pending'" @click="handleCancelOrder">取消订单</el-button>
        <el-button v-if="paymentStatus === 'pending'" type="primary" @click="refreshPaymentStatus">刷新状态</el-button>
        <el-button v-if="paymentStatus !== 'pending'" type="primary" @click="closePaymentStatusModal">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
  getUserBalance, 
  getRechargePackages, 
  createRechargeOrder,

  getUserUsageHistory, 
  getUserPurchaseHistory,
  handlePaymentCallback,
  getOrderStatus,
  cancelOrder
} from '@/api/auth'

export default {
  name: 'UserBalance',
  data() {
    return {
      activeTab: 'usage',
      userBalance: {},
      rechargePackages: [],
      showRechargeModal: false,
      selectedPackage: null,
      paymentMethod: '',
      rechargeLoading: false,
      
      // 支付相关
      currentOrderId: null,
      paymentStatusCheckInterval: null,
      paymentCountdownInterval: null,
      showPaymentStatusModal: false,
      paymentStatus: 'pending', // pending, success, failed, timeout
      qrCodeUrl: null,
      paymentCountdown: 300, // 5分钟倒计时
      tokensAdded: 0,
      useDirectLtzfApi: false, // 默认使用后端代理，避免CORS问题
      
      // 使用记录
      usageHistory: [],
      usageLoading: false,
      usageCurrentPage: 1,
      usageTotalCount: 0,
      usageFilter: {
        dateRange: []
      },
      
      // 购买记录
      purchaseHistory: [],
      purchaseLoading: false,
      purchaseCurrentPage: 1,
      purchaseTotalCount: 0,
      purchaseFilter: {
        dateRange: []
      },
      
      pageSize: 10,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    currentUserId() {
      return this.$store.state.userId
    },
    isMobile() {
      return this.windowWidth <= 768
    }
  },
  mounted() {
    this.initData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 清理所有定时器
    this.stopPaymentStatusCheck()
    this.stopPaymentCountdown()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    async initData() {
      await this.fetchUserBalance()
      await this.fetchRechargePackages()
      await this.fetchUsageHistory()
    },
    
    async fetchUserBalance() {
      try {
        const response = await getUserBalance(this.currentUserId)
        this.userBalance = response
      } catch (error) {
        this.$message.error('获取用户余额失败')
      }
    },
    
    async fetchRechargePackages() {
      try {
        const response = await getRechargePackages()
        this.rechargePackages = response.packages || []
      } catch (error) {
        this.$message.error('获取充值套餐失败')
      }
    },
    
    async fetchUsageHistory() {
      this.usageLoading = true
      try {
        const [startDate, endDate] = this.usageFilter.dateRange || ['', '']
        const response = await getUserUsageHistory(
          this.currentUserId, 
          startDate, 
          endDate, 
          this.usageCurrentPage, 
          this.pageSize
        )
        this.usageHistory = response.usage_history || []
        this.usageTotalCount = response.total || 0
      } catch (error) {
        this.$message.error('获取使用记录失败')
      } finally {
        this.usageLoading = false
      }
    },
    
    async fetchPurchaseHistory() {
      this.purchaseLoading = true
      try {
        const [startDate, endDate] = this.purchaseFilter.dateRange || ['', '']
        const response = await getUserPurchaseHistory(
          this.currentUserId, 
          startDate, 
          endDate, 
          this.purchaseCurrentPage, 
          this.pageSize
        )
        this.purchaseHistory = response.purchase_history || []
        this.purchaseTotalCount = response.total || 0
      } catch (error) {
        this.$message.error('获取购买记录失败')
      } finally {
        this.purchaseLoading = false
      }
    },
    
    handleTabClick(tab) {
      if (tab.name === 'purchase' && this.purchaseHistory.length === 0) {
        this.fetchPurchaseHistory()
      }
    },
    
    handleUsagePageChange(page) {
      this.usageCurrentPage = page
      this.fetchUsageHistory()
    },
    
    handlePurchasePageChange(page) {
      this.purchaseCurrentPage = page
      this.fetchPurchaseHistory()
    },
    
    refreshUsageHistory() {
      this.usageCurrentPage = 1
      this.fetchUsageHistory()
    },
    
    refreshPurchaseHistory() {
      this.purchaseCurrentPage = 1
      this.fetchPurchaseHistory()
    },
    
    selectPackage(pkg) {
      this.selectedPackage = pkg
    },
    
    async handleRecharge() {
      if (!this.selectedPackage || !this.paymentMethod) {
        this.$message.warning('请选择充值套餐和支付方式')
        return
      }
      
      this.rechargeLoading = true
      try {
        let response;
        

          // 通过后端调用
          response = await createRechargeOrder(
            this.currentUserId,
            this.selectedPackage.package_id,
            this.paymentMethod
          )

        
        console.log('充值套餐id:', this.selectedPackage.package_id)  
        console.log('支付方式:', this.paymentMethod)
        console.log('充值订单创建成功:', response)

        
        if (response) {
          this.currentOrderId = response.order_id
          this.qrCodeUrl = response.qr_code_url // 蓝兔支付返回的二维码URL
          
          // 检查是否成功获取二维码
          if (!this.qrCodeUrl) {
            this.$message.error('获取支付二维码失败，请重试')
            return
          }
          
          this.showRechargeModal = false
          this.showPaymentStatusModal = true
          this.paymentStatus = 'pending'
          
          // 开始倒计时和状态检查
          this.startPaymentCountdown()
          this.startPaymentStatusCheck()
          
          this.$message.success('充值订单创建成功，请扫码支付')
        } else {
          this.$message.error(response.message || '充值失败')
        }
      } catch (error) {
        console.error('创建充值订单失败:', error)
        this.$message.error('创建充值订单失败')
      } finally {
        this.rechargeLoading = false
      }
    },
    
    // 开始支付倒计时
    startPaymentCountdown() {
      this.paymentCountdown = 300 // 重置为5分钟
      this.paymentCountdownInterval = setInterval(() => {
        this.paymentCountdown--
        if (this.paymentCountdown <= 0) {
          this.paymentStatus = 'timeout'
          this.stopPaymentCountdown()
          this.stopPaymentStatusCheck()
          this.$message.warning('支付超时，订单已关闭')
        }
      }, 1000)
    },
    
    // 停止支付倒计时
    stopPaymentCountdown() {
      if (this.paymentCountdownInterval) {
        clearInterval(this.paymentCountdownInterval)
        this.paymentCountdownInterval = null
      }
    },
    
    // 处理支付结果
    async handlePaymentResult(status, transactionId, tokensAdded = 0) {
      try {
        if (this.currentOrderId) {
          const response = await handlePaymentCallback(
            this.currentOrderId,
            status,
            transactionId
          )
          
          if (status === 'success' || status === 'paid') {
            this.paymentStatus = 'success'
            this.tokensAdded = tokensAdded || response.tokens_added || this.selectedPackage?.tokens || 0
            this.$message.success(`支付成功！获得 ${this.tokensAdded} tokens`)
            
            // 刷新余额和购买记录
            await this.fetchUserBalance()
            await this.fetchPurchaseHistory()
          } else {
            this.paymentStatus = 'failed'
            this.$message.error('支付失败，请重试')
          }
          
          this.stopPaymentStatusCheck()
          this.stopPaymentCountdown()
        }
      } catch (error) {
        console.error('处理支付结果失败:', error)
        this.paymentStatus = 'failed'
        this.$message.error('支付处理失败')
        this.stopPaymentStatusCheck()
        this.stopPaymentCountdown()
      }
    },
    
    // 开始检查支付状态
    startPaymentStatusCheck() {
      this.paymentStatusCheckInterval = setInterval(async () => {
        try {
          if (this.currentOrderId) {
            const response = await getOrderStatus(this.currentOrderId)
            
            if (response.status === 'paid' || response.status === 'success') {
              this.paymentStatus = 'success'
              this.tokensAdded = response.tokens_added || this.selectedPackage?.tokens || 0
              this.$message.success('支付成功！')
              await this.fetchUserBalance()
              await this.fetchPurchaseHistory()
              this.stopPaymentStatusCheck()
              this.stopPaymentCountdown()
            } else if (response.status === 'failed' || response.status === 'cancelled') {
              this.paymentStatus = 'failed'
              this.$message.error('支付失败')
              this.stopPaymentStatusCheck()
              this.stopPaymentCountdown()
            }
          }
        } catch (error) {
          console.error('检查支付状态失败:', error)
        }
      }, 3000) // 每3秒检查一次
    },
    
    // 停止检查支付状态
    stopPaymentStatusCheck() {
      if (this.paymentStatusCheckInterval) {
        clearInterval(this.paymentStatusCheckInterval)
        this.paymentStatusCheckInterval = null
      }
    },
    
    // 重新生成二维码
    async retryGenerateQRCode() {
      if (!this.currentOrderId || !this.selectedPackage || !this.paymentMethod) {
        return
      }
      
      try {
        const response = await createRechargeOrder(
          this.currentUserId,
          this.selectedPackage.package_id,
          this.paymentMethod
        )
        
        if (response.success && response.qr_code_url) {
          this.qrCodeUrl = response.qr_code_url
          this.$message.success('二维码重新生成成功')
        } else {
          this.$message.error('重新生成二维码失败')
        }
      } catch (error) {
        console.error('重新生成二维码失败:', error)
        this.$message.error('重新生成二维码失败')
      }
    },
    async refreshPaymentStatus() {
      try {
        if (this.currentOrderId) {
          const response = await getOrderStatus(this.currentOrderId)
          
          if (response.status === 'paid' || response.status === 'success') {
            this.paymentStatus = 'success'
            this.tokensAdded = response.tokens_added || this.selectedPackage?.tokens || 0
            this.$message.success('支付成功！')
            await this.fetchUserBalance()
            await this.fetchPurchaseHistory()
            this.stopPaymentStatusCheck()
            this.stopPaymentCountdown()
          } else if (response.status === 'failed' || response.status === 'cancelled') {
            this.paymentStatus = 'failed'
            this.$message.error('支付失败')
            this.stopPaymentStatusCheck()
            this.stopPaymentCountdown()
          } else {
            this.$message.info('订单状态：' + response.status)
          }
        }
      } catch (error) {
        this.$message.error('检查支付状态失败')
      }
    },
    
    // 取消订单
    async handleCancelOrder() {
      try {
        if (this.currentOrderId) {
          await cancelOrder(this.currentOrderId)
          this.showPaymentStatusModal = false
          this.stopPaymentStatusCheck()
          this.stopPaymentCountdown()
          this.resetPaymentState()
          this.$message.info('订单已取消')
        }
      } catch (error) {
        this.$message.error('取消订单失败')
      }
    },
    
    // 关闭支付状态弹窗
    closePaymentStatusModal() {
      this.showPaymentStatusModal = false
      this.stopPaymentStatusCheck()
      this.stopPaymentCountdown()
      this.resetPaymentState()
    },
    
    // 重置支付状态
    resetPaymentState() {
      this.currentOrderId = null
      this.paymentStatus = 'pending'
      this.qrCodeUrl = null
      this.paymentCountdown = 300
      this.tokensAdded = 0
      this.selectedPackage = null
      this.paymentMethod = ''
    },
    
    getStatusClass(status) {
      switch (status) {
        case 'paid':
          return 'status-success'
        case 'pending':
          return 'status-pending'
        case 'failed':
          return 'status-failed'
        default:
          return ''
      }
    },
    
    getStatusText(status) {
      switch (status) {
        case 'paid':
          return '已完成'
        case 'pending':
          return '处理中'
        case 'failed':
          return '失败'
        default:
          return '未知'
      }
    },
    
    // 格式化时间：2025-09-16T20:09:16.358000 → 2025-09-16 20:09:16
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) {
        return '-'
      }
      
      try {
        // 处理ISO格式时间字符串
        const date = new Date(dateTimeStr)
        
        // 检查日期是否有效
        if (isNaN(date.getTime())) {
          return dateTimeStr // 如果无法解析，返回原字符串
        }
        
        // 格式化为 YYYY-MM-DD HH:mm:ss
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      } catch (error) {
        console.error('时间格式化失败:', error)
        return dateTimeStr // 出错时返回原字符串
      }
    },
    
    // 格式化日期：2025-09-16T20:09:16.358000 → 2025-09-16
    formatDate(dateStr) {
      if (!dateStr) {
        return '-'
      }
      
      try {
        // 如果已经是简单的日期格式（YYYY-MM-DD），直接返回
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
          return dateStr
        }
        
        // 处理ISO格式时间字符串
        const date = new Date(dateStr)
        
        // 检查日期是否有效
        if (isNaN(date.getTime())) {
          return dateStr // 如果无法解析，返回原字符串
        }
        
        // 格式化为 YYYY-MM-DD
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        
        return `${year}-${month}-${day}`
      } catch (error) {
        console.error('日期格式化失败:', error)
        return dateStr // 出错时返回原字符串
      }
    }
  }
}
</script>

<style scoped>
.balance-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section h2 {
  margin-bottom: 20px;
  color: #333;
}

.balance-card {
  margin-top: 70px; 
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 30px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.balance-info {
  display: flex;
  gap: 60px;
}

.balance-item {
  text-align: center;
}

.balance-item .label {
  display: block;
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 8px;
}

.balance-item .value {
  display: block;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 4px;
}

.balance-item .unit {
  font-size: 14px;
  opacity: 0.8;
}

.recharge-btn {
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
}

.recharge-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.filter-bar {
  margin-bottom: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
}

.tokens-used {
  color: #f56c6c;
  font-weight: bold;
}

.tokens-gained {
  color: #67c23a;
  font-weight: bold;
}

.status-success {
  color: #67c23a;
}

.status-pending {
  color: #e6a23c;
}

.status-failed {
  color: #f56c6c;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}

/* 充值弹窗样式 */
.recharge-content {
  padding: 20px 0;
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
  margin-bottom: 30px;
}

.package-card {
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}

.package-card:hover {
  border-color: #409eff;
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.2);
}

.package-card.selected {
  border-color: #409eff;
  background: rgba(64, 158, 255, 0.05);
}

.package-header h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
}

.package-price {
  font-size: 24px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 10px;
}

.package-desc {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.package-bonus {
  font-size: 12px;
  color: #67c23a;
  font-weight: bold;
}

.payment-section {
  border-top: 1px solid #e4e7ed;
  padding-top: 20px;
}

.payment-section h4 {
  margin-bottom: 15px;
  color: #333;
}

.payment-methods {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.payment-method {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 100px;
}

.payment-method:hover {
  border-color: #409eff;
}

.payment-method.selected {
  border-color: #409eff;
  background: rgba(64, 158, 255, 0.05);
}

.payment-method img {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
}

.payment-method span {
  font-size: 14px;
  color: #333;
}

.order-summary {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 6px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.summary-item.total {
  font-weight: bold;
  font-size: 16px;
  border-top: 1px solid #ddd;
  padding-top: 8px;
}

.summary-item .price {
  color: #f56c6c;
}

/* 支付状态弹窗样式 */
.payment-status-content {
  text-align: center;
  padding: 20px 0;
}

/* 二维码支付区域 */
.qr-code-section {
  padding: 20px 0;
}

.payment-info {
  margin-bottom: 30px;
}

.payment-info h3 {
  margin: 0 0 15px 0;
  font-size: 18px;
  color: #333;
}

.order-amount {
  font-size: 32px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 10px;
}

.qr-code-container {
  margin-bottom: 20px;
}

.qr-code {
  width: 200px;
  height: 200px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  margin-bottom: 15px;
}

.qr-code-loading {
  width: 200px;
  height: 200px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  margin: 0 auto 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f7fa;
}

.qr-code-loading i {
  font-size: 24px;
  color: #409eff;
  margin-bottom: 10px;
}

.qr-code-loading p {
  margin: 0 0 10px 0;
  font-size: 12px;
  color: #666;
}

.qr-code-tips {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.qr-code-tips p {
  margin: 5px 0;
}

.payment-countdown {
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px;
}

.payment-countdown p {
  margin: 0;
  font-size: 14px;
  color: #e6a23c;
  font-weight: bold;
}

/* 状态显示区域 */
.status-display {
  padding: 20px 0;
}

.status-icon {
  margin-bottom: 20px;
}

.status-icon i {
  font-size: 48px;
}

.status-loading i {
  color: #409eff;
  animation: rotate 1s linear infinite;
}

.status-success i {
  color: #67c23a;
}

.status-failed i {
  color: #f56c6c;
}

.status-timeout i {
  color: #e6a23c;
}

.status-text h3 {
  margin: 0 0 10px 0;
  font-size: 18px;
  color: #333;
}

.status-text p {
  margin: 0 0 20px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.order-info {
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px;
}

.order-info p {
  margin: 0;
  font-size: 12px;
  color: #999;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .balance-page {
    margin-top:70px;
    padding: 10px;
  }

  .balance-card {
    margin-top: 20px;
    flex-direction: column;
    padding: 20px 15px;
    gap: 20px;
  }

  .balance-info {
    gap: 30px;
    width: 100%;
    justify-content: center;
  }

  .balance-item .value {
    font-size: 24px;
  }

  .recharge-btn {
    width: 100%;
  }

  /* 充值弹窗手机端适配 */
  .packages-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .package-card {
    padding: 12px 8px;
  }

  .package-header h3 {
    font-size: 14px;
  }

  .package-price {
    font-size: 18px;
  }

  .package-desc {
    font-size: 11px;
  }

  .package-bonus {
    font-size: 11px;
  }

  .payment-methods {
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .payment-method {
    min-width: 80px;
    padding: 10px;
  }

  .payment-method img {
    width: 32px;
    height: 32px;
  }

  .payment-method span {
    font-size: 12px;
  }

  .order-summary {
    padding: 12px;
  }

  .summary-item {
    font-size: 14px;
  }

  .summary-item.total {
    font-size: 14px;
  }

  /* 支付状态弹窗手机端适配 */
  .payment-info h3 {
    font-size: 16px;
  }

  .order-amount {
    font-size: 26px;
  }

  .qr-code {
    width: 180px;
    height: 180px;
  }

  .qr-code-loading {
    width: 180px;
    height: 180px;
  }

  .qr-code-tips {
    font-size: 12px;
  }

  .payment-countdown p {
    font-size: 12px;
  }

  .status-icon i {
    font-size: 40px;
  }

  .status-text h3 {
    font-size: 16px;
  }

  .status-text p {
    font-size: 12px;
  }

  /* 表格在手机端滚动 */
  .records-section {
    overflow-x: auto;
  }

  .filter-bar {
    flex-wrap: wrap;
  }
}

/* 更小屏幕适配 */
@media screen and (max-width: 480px) {
  .packages-grid {
    grid-template-columns: 1fr;
  }

  .package-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }

  .package-header {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .package-header h3 {
    margin: 0;
  }

  .package-price {
    margin: 0;
    font-size: 16px;
  }

  .package-desc,
  .package-bonus {
    display: none;
  }

  .qr-code {
    width: 160px;
    height: 160px;
  }

  .qr-code-loading {
    width: 160px;
    height: 160px;
  }
}
</style>
